module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "contents-"
  }, [_c('a', {
    attrs: {
      "href": "#/preface.htm#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/note_on_conventions.htm#conven"
    }
  }, [_vm._v("Note on Conventions")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/part_01.htm#part1"
    }
  }, [_vm._v("PART I  YOUNG CHARLES")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_01.htm#chap1"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("  1 ")]), _vm._v("From Duke of Luxemburg to Prince of Castile, 1500–8")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_02.htm#chap2"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("  2 ")]), _vm._v("The Orphan Prince, 1509–14")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_03.htm#chap3"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("  3 ")]), _vm._v("The Difficult Inheritance, 1515–17")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/portrait_01.htm#portrait1"
    }
  }, [_c('i', [_vm._v("Portrait of the Emperor as a Young Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/part_02.htm#part2"
    }
  }, [_vm._v("PART II  GAME OF THRONES")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_04.htm#chap4"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("  4 ")]), _vm._v("From King of Spain to King of the Romans, 1517–19")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_05.htm#chap5"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("  5 ")]), _vm._v("From Peace through Rebellion to War, 1519–21")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_06.htm#chap6"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("  6 ")]), _vm._v("Snatching Victory from the Jaws of Defeat, 1521–5")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_07.htm#chap7"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("  7 ")]), _vm._v("Snatching Defeat from the Jaws of Victory, 1525–8")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_08.htm#chap8"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("  8 ")]), _vm._v("Champion of the Western World, 1528–31")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/portrait_02.htm#portrait2"
    }
  }, [_c('i', [_vm._v("Portrait of the Emperor as a Renaissance Prince")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/part_03.htm#part3"
    }
  }, [_vm._v("PART III  ‘RULER FROM THE RISING TO THE SETTING "), _c('br'), _vm._v("OF THE SUN’")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_09.htm#chap9"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("  9 ")]), _vm._v("The Last Crusader, 1532–6")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_10.htm#chap10"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("10 ")]), _vm._v("Years of Defeat, 1536–41")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_11.htm#chap11"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("11 ")]), _vm._v("Settling Scores, Part I: Guelders and France, 1541–4")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_12.htm#chap12"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("12 ")]), _vm._v("Settling Scores, Part II: Germany and Italy, 1545–8")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_13.htm#chap13"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("13 ")]), _vm._v("The Taming of America")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/portrait_03.htm#portrait3"
    }
  }, [_c('i', [_vm._v("Portrait of the Emperor in his Prime")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "id": "pVIII"
    }
  }), _c('a', {
    attrs: {
      "href": "#/part_04.htm#part4"
    }
  }, [_vm._v("PART  IV DOWNFALL")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_14.htm#chap14"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("14 ")]), _vm._v("Paterfamilias, 1548–51")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_15.htm#chap15"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("15 ")]), _vm._v("The Emperor’s Last Campaigns, 1551–4")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_16.htm#chap16"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("16 ")]), _vm._v("Restless Retirement, 1555–8")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_17.htm#chap17"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("17 ")]), _vm._v("The Emperor in Legend and History")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/epilogue.htm#epilo"
    }
  }, [_vm._v("Epilogue: The Balance of the Reign")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct2"
  }, [_c('a', {
    attrs: {
      "href": "#/appendices.htm#app"
    }
  }, [_vm._v("Appendices:")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-a"
  }, [_c('a', {
    attrs: {
      "href": "#/appendices.htm#app1"
    }
  }, [_vm._v("I. The Emperor’s "), _c('i', [_vm._v("Memoirs")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-a"
  }, [_c('a', {
    attrs: {
      "href": "#/appendices.htm#app2"
    }
  }, [_vm._v("II. The Afterlife of Charles V’s Body")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-a"
  }, [_c('a', {
    attrs: {
      "href": "#/appendices.htm#app3"
    }
  }, [_vm._v("III. The Emperor’s Last Instructions to Philip II")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-a"
  }, [_c('a', {
    attrs: {
      "href": "#/appendices.htm#app4"
    }
  }, [_vm._v("IV. ‘Infanta Isabel of Castile, daughter of His "), _c('br'), _vm._v("Majesty the emperor’")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements.htm#ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chronology.htm#chrono"
    }
  }, [_vm._v("Chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/abbreviations.htm#abbrev"
    }
  }, [_vm._v("Abbreviations in the Notes and Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/note_on_dates_and_quotes.htm#dates"
    }
  }, [_vm._v("Note on Dates and Quotes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/note_on_sources.htm#sources"
    }
  }, [_vm._v("Note on Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliography.htm#biblio"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/list_of_maps_figures_and_plates.htm#list"
    }
  }, [_vm._v("List of Maps, Figures and Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#index"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0